export const aerospikeConfig = {
    hosts: process.env.BUILD_ENV === 'prod' ? 'aerospike-grd-cabs-1.db-prd.mmt.internal,aerospike-grd-cabs-2.db-prd.mmt.internal,aerospike-grd-cabs-3.db-prd.mmt.internal'
     : 'aspk-grd.db-npd.mmt.internal',
}

